<template>
  <div
    class="theme-square-check"
    :class="{
      'theme-square-check_empty': !checked,
      'theme-square-check_gray': gray || disabled,
      'theme-square-check_disabled': disabled,
    }"
    @click="click"
  >
    <i class="icon icon-check" />
  </div>
</template>

<script setup>
const props = defineProps({
  checked: { type: Boolean, default: false },
  gray: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})
const emit = defineEmits(['click'])

function click() {
  if (props.disabled) return
  emit('click')
}
</script>

<style lang="scss" scoped>
$size: 16px;

.theme-square-check {
  border: 1px solid $brand-tertiary;
  border-radius: 2px;
  color: $white;
  background-color: $brand-tertiary;
  cursor: pointer;

  &,
  .icon-check {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: $size;
    height: $size;
  }

  &_empty {
    background-color: $white;

    .icon {
      visibility: hidden;
    }
  }

  &_gray,
  &_disabled {
    background-color: $gray-lighter;
    color: $gray;
    border-color: $gray-lighter;
  }

  &_disabled {
    pointer-events: none;
  }

  .icon {
    text-align: center;

    &:before {
      transform: scale(0.8);
    }
  }
}
</style>
